import { SaleStep } from "./stepSaleConfigReducer";

/**
 * Returns the localized text for a stepSaleConfig field.
 * When the app language is not Polish and an English translation exists, uses it.
 * Whitespace-only English is treated as missing. Falls back to the Polish value.
 */
export const getLocalizedStepText = (plText: string, enText: string | undefined, language: string): string => {
  const english = enText?.trim();
  if (language !== "PL" && english) {
    return english;
  }
  return plText ?? "";
};

const localizeField = (plText: string | undefined, enText: string | undefined, language: string) =>
  getLocalizedStepText(plText ?? "", enText, language);

/** Banner copy with English applied only when the shop language is not Polish and the translation is filled in. */
export const localizeSaleStep = (saleStep: SaleStep, language: string): SaleStep => ({
  ...saleStep,
  bannerLabel: localizeField(saleStep.bannerLabel, saleStep.bannerLabel_en, language),
  buttonCustomTitle: localizeField(saleStep.buttonCustomTitle, saleStep.buttonCustomTitle_en, language),
  priceLabel: localizeField(saleStep.priceLabel, saleStep.priceLabel_en, language),
  highlightedFeature1: localizeField(saleStep.highlightedFeature1, saleStep.highlightedFeature1_en, language),
  highlightedFeature2: localizeField(saleStep.highlightedFeature2, saleStep.highlightedFeature2_en, language),
  highlightedFeature3: localizeField(saleStep.highlightedFeature3, saleStep.highlightedFeature3_en, language),
});
